import { Link } from 'react-router-dom';
import { videos, latestIds } from '@/mocks/videos';

export default function LatestUpdates() {
  const latest = latestIds.map((id) => videos.find((v) => v.id === id)).filter(Boolean);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            <i className="ri-timer-line text-primary-500 mr-2"></i>最近更新
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            全部更新 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {latest.map((video) => video && (
            <Link
              key={video.id}
              to={`/video/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-2.5">
                <img
                  src={video.coverImage}
                  alt={video.title}
                  title={`${video.title} - 51影视免费在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md font-medium">
                    更新
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <p className="text-xs text-white/80 font-medium">{video.duration}</p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{video.category}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-foreground-500">{(video.views / 10000).toFixed(0)}万次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}